module.exports = __webpack_public_path__ + "dist/introduce_1.855c618e.png";